import React, { useState, useEffect, useRef } from 'react';

const steps = [
  { id: 1, title: "Analyzing the Requirements", desc: "Continuously analyze and refine requirements throughout the project.", points: ["Business goal alignment", "Technical feasibility study", "Requirement documentation"], img: "/assets/img/Home/P1.png" },
  { id: 2, title: "Wireframing & Designs", desc: "Create visual blueprints and design concepts for the app.", points: ["User experience (UX) strategy", "High-fidelity UI mockups", "Interactive prototyping"], img: "/assets/img/Home/P2.png" },
  { id: 3, title: "Development", desc: "Transform designs into a fully functional mobile application.", points: ["Clean & scalable coding", "API & Database integration", "Frontend & Backend synchronization"], img: "/assets/img/Home/P3.png" },
  { id: 4, title: "Deployment", desc: "Deploy the app to the intended platforms, such as app stores.", points: ["App Store & Play Store optimization", "Server environment setup", "Production release management"], img: "/assets/img/Home/P4.png" },
  { id: 5, title: "Testing", desc: "Thoroughly test the app to ensure it functions flawlessly and meets quality standards.", points: ["Unit & Regression testing", "Security & Load testing", "Bug tracking & resolution"], img: "/assets/img/Home/P5.png" },
  { id: 6, title: "Launch", desc: "Make the app available to users and promote its release.", points: ["Live environment monitoring", "User onboarding guide", "Market launch execution"], img: "/assets/img/Home/P6.png" },
  { id: 7, title: "Post Launch Support", desc: "Provide ongoing support, updates, and maintenance to ensure optimal app performance.", points: ["24/7 technical maintenance", "Performance optimization", "Iterative feature updates"], img: "/assets/img/Home/P7.png" },
];

const DeliveryProcess = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Scroll logic for vertical nav dots synchronization
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    const handleScroll = () => {
      const triggerPoint = window.innerHeight * 0.4;
      steps.forEach((step) => {
        const element = document.getElementById(`step-${step.id}`);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= triggerPoint && rect.bottom >= triggerPoint) {
            setActiveStep(step.id);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  // Button navigation function
  const scrollToStep = (id) => {
    const el = document.getElementById(`step-${id}`);
    if (el) {
      const offset = 80; // Header offset
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = el.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const skipToNext = () => {
    if (sectionRef.current) {
      // Section jya khatam thay che tya sudhi scroll thase
      const sectionBottom = sectionRef.current.offsetTop + sectionRef.current.offsetHeight;
      window.scrollTo({
        top: sectionBottom,
        behavior: 'smooth'
      });
    }
  };
  return (
    <div className="delivery-main-wrapper" ref={sectionRef}>
      {/* Right Vertical Nav - Desktop Only */}
      <nav className={`right-vertical-nav ${isVisible ? 'visible' : ''}`}>
        <div className="vertical-line-bg">
          <div
            className="vertical-line-active"
            style={{ height: `${((activeStep - 1) / (steps.length - 1)) * 100}%` }}
          ></div>
        </div>
        {steps.map((step) => (
          <div
            key={step.id}
            className={`nav-dot-wrapper ${activeStep === step.id ? 'active' : ''}`}
            onClick={() => scrollToStep(step.id)}
          >
            {/* <span className="dot-label">{step.title.split(' ')[0]}</span> */}
            <span className="dot-label">{step.title}</span>

            <div className="nav-dot"></div>

          </div>

        ))}
        <div className="skip-container">
          <button
            className="skip-link"
            onClick={skipToNext}
          >
            SKIP →
          </button>
        </div>
      </nav>

      <div className="process-header">
        <h1 className="main-title-text">How we Deliver Customer's Expectations</h1>
      </div>

      <div className="delivery-container">
        {steps.map((step, index) => (
          <div
            key={step.id}
            id={`step-${step.id}`}
            className={`process-row ${index % 2 === 0 ? 'left-img' : 'right-img'}`}
          >
            <div className="image-holder">
              <div className="glow-effect"></div>
              <img src={step.img} alt={step.title} className="big-process-img" />
            </div>

            <div className="content-holder section-tab">
              <h2 className="title">{step.title}</h2>
              <p className="main-desc">{step.desc}</p>
              <ul className="bullet-points">
                {step.points.map((point, i) => (
                  <li key={i}><span className="check-icon">✔</span> {point}</li>
                ))}
              </ul>

              {/* Step Navigation Buttons */}
              <div className="step-navigation-btns">
                {activeStep > 1 && (
                  <button className="nav-btn prev" onClick={() => scrollToStep(activeStep - 1)}>
                    ← PREVIOUS
                  </button>
                )}

                {activeStep < steps.length ? (
                  <button className="nav-btn next" onClick={() => scrollToStep(activeStep + 1)}>
                    NEXT →
                  </button>
                ) : (
                  <button className="nav-btn next finish">FINISH</button>
                )}
              </div>
            </div>

            {index < steps.length - 1 && (
              <div className="dashed-path">
                <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <path
                    d={index % 2 === 0
                      ? "M 70 30 C 70 60, 30 70, 30 100"
                      : "M 30 30 C 30 60, 70 70, 70 100"
                    }
                    stroke="white"
                    strokeWidth="0.3"
                    fill="transparent"
                    strokeDasharray="2,2"
                  />
                </svg>
              </div>
            )}

          </div>
        ))}

        {/* Bottom Skip Button */}

      </div>
    </div>
  );
};

export default DeliveryProcess;